import {
  TOUR_TOOLTIP_AREA_ELEMENT_ID,
  type TourStep,
} from '@carboncopyco/types';
import { createAreaElement } from './createAreaElement';

interface GetTargetElementFromAreaArgs {
  documentRoot: Document;
  elementPosition: TourStep['elementPosition'];
}

type ReturnType = {
  targetElement: HTMLElement;
  documentRoot: Document;
};

export const getTargetElementFromArea = ({
  documentRoot = document,
  elementPosition,
}: GetTargetElementFromAreaArgs): ReturnType => {
  let area = documentRoot.getElementById(TOUR_TOOLTIP_AREA_ELEMENT_ID);

  if (!area && elementPosition) {
    const { xTopLeft, yTopLeft, width, height } = elementPosition;
    area = createAreaElement({
      x: xTopLeft,
      y: yTopLeft,
      width,
      height,
      isHidden: true,
    });
  }

  return {
    targetElement: area,
    documentRoot,
  };
};
